<template>
<div class="segment-main">
  <h1 class="title has-text-centered">Gamesheet Cards </h1>
 
  <span v-if="this.Gamesheet.length <= 0"><h2 class="segment title has-text-centered">No data or Loading...</h2></span>
  <div class="segment" v-for="player in this.Gamesheet" v-bind:key="player.number">
      <div v-if="player.number!==null">
    <h2 class="subtitle has-text-centered devils">{{player.number}}</h2>
        <div class="columns">
            <div class="column">
                <h2 class="subheading  has-text-centered">Goals</h2>
                <p class="stat-number has-text-centered">+ {{player.goals_for}}</p>
                <p class="stat-number has-text-centered">- {{player.goals_for}}</p>
                <p class="stat-number has-text-centered">+/- {{player.goal_diff}}</p>
            </div>
            <div class="column">
                <h2 class="subheading has-text-centered">Faceoffs</h2>
                <p class="stat-number has-text-centered"> Won / Taken {{player.fo}}</p>
            </div>
            <div class="column">
                <h2 class="subheading  has-text-centered">Shots</h2>
                <p class="stat-number has-text-centered">+ {{player.shots_for}}</p>
                <p class="stat-number has-text-centered">- {{player.shots_against}}</p>
                <p class="stat-number has-text-centered">+/- {{player.shots_plus_minus}}</p>
                <p class="stat-number has-text-centered">On Net {{player.sot}}</p>
            </div>
            <div class="column">
                <h2 class="subheading  has-text-centered">Ice Time</h2>
                <p class="stat-number has-text-centered">Total TOI{{player.total_toi}}</p>
                <p class="stat-number has-text-centered">Shifts {{player.shifts}}</p>
                <p class="stat-number has-text-centered">Average {{player.avg_shift}}</p>
                <p class="stat-number has-text-centered">Even Handed {{player.eh_time}}</p>
                <p class="stat-number has-text-centered">Power Play {{player.pp_time}}</p>
                <p class="stat-number has-text-centered">Short Handed {{player.sh_time}}</p>
                
            </div>
        </div>
    </div>
    </div>
</div>
</template>

<script>
export default {
  props: {
    game_id: { type: Number, required: true },
    period: { type: Number, required: true }
  },
  data () {
    return {
      Gamesheet: []
    }
  },
  methods: {
    fetchStats () {
      this.tableData = []
      this.$http
        .get('https://devilsapi.roblutken.com/api/app/get/match-stats/' + this.$route.params.gameId + '/' + this.$route.params.period, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
        })
        .then(
          response => {
            this.Gamesheet = response.data
            console.log('Gamesheet data: ' + JSON.stringify(this.Gamesheet))
          },
          response => {}
        )
    }
  },
  watch: {
    game_id: {
      handler: function (endpoint) {
        this.fetchStats()
      },
      immediate: true
    }
  },
  created: function () {
    this.fetchStats()
  }
}
</script>

<style lang="scss" scoped>
thead, th {
    background-color: #8b0505d1;
}
.table tr:hover {
    background-color: #8b0505d1;
    color: #fff;
    margin: 0 auto;
}
.table thead td, .table thead th{
  color: #fff;
}
.devils{
  background-color: #8b0505d1;
  color: #fff;
}
.subtitle{
    color:white;
}
/* scrolltable rules */
table  {     width:100%; 
    margin-left:auto; 
    margin-right:auto;  overflow: auto; }
th div { margin-top: -20px; position: absolute; }

/* design */
table { border-collapse: collapse; }
tr:nth-child(even) { background: #EEE; }
.main-table{
  max-width: 90%
}
.segment-main {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 70%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.small-box {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment-main h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment-main h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment h2 {
  color:rgb(255, 255, 255);
  margin-top:0.4em;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2em;
}
.subheading{
  color:rgb(255, 255, 255);
  margin-top:0.4em;
  margin-left:0.4em;
  font-weight: 500;
  text-transform: uppercase;
  font-size: 1.4em;
 background-color: #222222d1;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
.stat-title{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-category{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.5rem;
  margin: 1rem 0rem;
}
.stat-number{
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color:black;
}
</style>



// WEBPACK FOOTER //
// Gamesheet2021.vue?3a7ccf39